export const ICON_BASE_PATH = "https://prod-static-assets.amberstudent.com/images";
export const OTHER_BASE_PATH = "https://prod-static-assets.amberstudent.com/other";
export const ICON_BASE_PATH_S3 =
  "https://s3.ap-southeast-1.amazonaws.com/static-assets.amberstudent.com/images";
export const ICONS = {
  partnerEarth: `${ICON_BASE_PATH_S3}/partner_earth.png`,
  testimonials: `${ICON_BASE_PATH_S3}/double-quotes.png`,
  hightVisibility: `${ICON_BASE_PATH_S3}/growth.png`,
  reconcilation: `${ICON_BASE_PATH}/list-with-us/recon.svg`,
  map: `${ICON_BASE_PATH}/list-with-us/map.png`,
  listWithUsForm: `${ICON_BASE_PATH}/list-with-us-form.png`,
  growWithUs: `${ICON_BASE_PATH_S3}/growwithus.jpg`,
  listYourProperty: `${ICON_BASE_PATH}/List your property.jpg`,
  checkIcon: `${ICON_BASE_PATH_S3}/bubble_tick.png`,
  simplifiedSales: `${ICON_BASE_PATH}/list-with-us/simplified-sales.svg`,
  circle1: `${ICON_BASE_PATH}/circle-1-light.svg`,
  circle2: `${ICON_BASE_PATH}/circle-2-light.svg`,
  circle3: `${ICON_BASE_PATH}/circle-3-light.svg`,
  pmgPartners: [
    `${ICON_BASE_PATH}/iq_student_accommodation_(2).png`,
    `${ICON_BASE_PATH}/unite_student.png`,
    `${ICON_BASE_PATH}/homes for students.png`,
    `${ICON_BASE_PATH}/student roost_black.png`,
    `${ICON_BASE_PATH}/harrington_housing.png`,
    `${ICON_BASE_PATH}/varsity.png`,
    `${ICON_BASE_PATH}/Scape.png`,
    `${ICON_BASE_PATH}/YUGO.png`,
    `${ICON_BASE_PATH}/dwell.png`,
    `${ICON_BASE_PATH}/Fresh Student Living.png`,
    `${ICON_BASE_PATH}/crm.png`,
    `${ICON_BASE_PATH}/collegiate.png`,
    `${ICON_BASE_PATH}/prestige_student_living.png`,
  ],
  brandPartners: [
    `${ICON_BASE_PATH}/Skyscanner.png`,
    `${ICON_BASE_PATH}/american_tourister.png`,
    `${ICON_BASE_PATH}/ikea.png`,
    `${ICON_BASE_PATH}/grammarly.png`,
    `${ICON_BASE_PATH}/boat.png`,
    `${ICON_BASE_PATH}/cleartrip.png`,
    `${ICON_BASE_PATH}/uber.png`,
    `${ICON_BASE_PATH}/goibibo-logo.png`,
    `${ICON_BASE_PATH}/esky.png`,
    `${ICON_BASE_PATH}/ixigo.png`,
    `${ICON_BASE_PATH}/jayride.png`,
    `${ICON_BASE_PATH}/mastercard.png`,
    `${ICON_BASE_PATH}/yatra.png`,
    `${ICON_BASE_PATH}/world_university_rankings.png`,
    `${ICON_BASE_PATH}/spotify.png`,
  ],
  globalStatsIcons: {
    partnerEarth: `${ICON_BASE_PATH_S3}/partner_earth.png`,
    partnerCities: `${ICON_BASE_PATH_S3}/partner_cities_building.jpg`,
    partnerBeds: `${ICON_BASE_PATH_S3}/partner_beds.png`,
    partnerHouse: `${ICON_BASE_PATH_S3}/partner_house.jpg`,
  },
};

export const GLOBAL_STATS = [
  {
    count: "25+",
    text: "list.globalstats.stat1.text",
    label: "list.globalstats.stat1.label",
    icon: `${ICON_BASE_PATH_S3}/partner_earth.png`,
  },
  {
    count: "260+",
    text: "list.globalstats.stat2.text",
    label: "list.globalstats.stat2.label",
    icon: `${ICON_BASE_PATH_S3}/partner_cities_building.jpg`,
  },
  {
    count: "2M+",
    text: "list.globalstats.stat3.text",
    label: "list.globalstats.stat3.label",
    icon: `${ICON_BASE_PATH_S3}/partner_beds.png`,
  },
  {
    count: "35K+",
    text: "list.globalstats.stat4.text",
    textMobile: "list.globalstats.stat4.textMobile",
    label: "list.globalstats.stat4.label",
    icon: `${ICON_BASE_PATH_S3}/partner_house.jpg`,
  },
];

export const GROW_CARDS = [
  {
    title: "list.grow.card1.title",
    description: "list.grow.card1.description",
    hasBlueBackground: true,
  },
  {
    title: "list.grow.card2.title",
    description: "list.grow.card2.description",
    icon: "hightVisibility",
    height: "tall",
  },
  {
    title: "list.grow.card3.title",
    description: "list.grow.card3.description",
    hasBlueBackground: true,
  },
  {
    title: "list.grow.card4.title",
    description: "list.grow.card4.description",
    icon: "checkIcon",
    height: "tall",
  },
  {
    title: "list.grow.card5.title",
    description: "list.grow.card5.description",
    hasBlueBackground: true,
  },
  {
    title: "list.grow.card6.title",
    description: "list.grow.card6.description",
    icon: "partnerEarth",
    height: "tall",
  },
];

export const ACCOMMODATION_TYPES = (t: (key: string) => string) => ({
  "Purpose-built ( Student accommodation )": t(
    "searchpage.components.accommodationtypesnew.purposebuilt",
  ),

  "Managed accommodation (Build to rent)": t(
    "searchpage.components.accommodationtypesnew.managedaccommodation",
  ),

  "Independent house": t("searchpage.components.accommodationtypesnew.independenthouse"),
});

export const NAME_PREFIX = (t: (key: string) => string) => ({
  "Mr.": t("list.form.honorifics.mr"),
  "Mrs.": t("list.form.honorifics.mrs"),
  "Ms.": t("list.form.honorifics.ms"),
  "Dr.": t("list.form.honorifics.dr"),
});

export const DEFAULT_NAME_PREFIX = "Mr.";

export const STUDENTS_TESTIOMONIALS = [
  {
    id: "1",
    review: "list.testimonials.student1.review",
    reviewer: "list.testimonials.student1.reviewer",
    reviewerType: "list.testimonials.student1.reviewerType",
  },
  {
    id: "2",
    review: "list.testimonials.student2.review",
    reviewer: "list.testimonials.student2.reviewer",
    reviewerType: "list.testimonials.student2.reviewerType",
  },
  {
    id: "3",
    review: "list.testimonials.student3.review",
    reviewer: "list.testimonials.student3.reviewer",
    reviewerType: "list.testimonials.student3.reviewerType",
  },
];

export const PMG_TESTIMONIALS = [
  {
    id: "1",
    review: "list.testimonials.pmg1.review",
    reviewer: "list.testimonials.pmg1.reviewer",
    reviewerType: "list.testimonials.pmg1.reviewerType",
  },
  {
    id: "2",
    review: "list.testimonials.pmg2.review",
    reviewer: "list.testimonials.pmg2.reviewer",
    reviewerType: "list.testimonials.pmg2.reviewerType",
  },
  {
    id: "3",
    review: "list.testimonials.pmg3.review",
    reviewer: "list.testimonials.pmg3.reviewer",
    reviewerType: "list.testimonials.pmg3.reviewerType",
  },
];

export const FEATURES_DATA = [
  {
    id: 1,
    title: "list.features.card1.title",
    subtext: "list.features.card1.subtext",
    image: `${ICON_BASE_PATH_S3}/list-features-1-new.png`,
  },
  {
    id: 2,
    title: "list.features.card2.title",
    subtext: "list.features.card2.subtext",
    image: `${ICON_BASE_PATH_S3}/list-features-2-new.png`,
  },
  {
    id: 3,
    title: "list.features.card3.title",
    subtext: "list.features.card3.subtext",
    image: `${ICON_BASE_PATH_S3}/list-features-3-new.png`,
  },
];

export const CASE_STUDIES = [
  {
    id: "1",
    name: "list.casestudies.study1.name",
    image: `${ICON_BASE_PATH_S3}/amber-londonist-new.png`,
    description: "list.casestudies.study1.description",
    pdf: `${OTHER_BASE_PATH}/londonist-amber.pdf`,
  },
  {
    id: "2",
    name: "list.casestudies.study2.name",
    image: `${ICON_BASE_PATH_S3}/amber-june-new.png`,
    description: "list.casestudies.study2.description",
    pdf: `${OTHER_BASE_PATH}/amber-june-homes-case-study.pdf`,
  },
  {
    id: "3",
    name: "list.casestudies.study3.name",
    image: `${ICON_BASE_PATH_S3}/amber-zuma-new.png`,
    description: "list.casestudies.study3.description",
    pdf: `${OTHER_BASE_PATH}/amber-zuma-housing-case-study.pdf`,
  },
  {
    id: "4",
    name: "list.casestudies.study4.name",
    image: `${ICON_BASE_PATH_S3}/amber-axo-new.png`,
    description: "list.casestudies.study4.description",
    pdf: `${OTHER_BASE_PATH}/amber-strategic-partnership-with-axo-student-living-case-study.pdf`,
  },
];

export const frequentlyAskedQuestions = [
  {
    id: 1,
    label: "list.faq.q1.label",
    content: "list.faq.q1.content",
  },
  {
    id: 2,
    label: "list.faq.q2.label",
    content: "list.faq.q2.content",
  },
  {
    id: 3,
    label: "list.faq.q3.label",
    content: "list.faq.q3.content",
  },
  {
    id: 4,
    label: "list.faq.q4.label",
    content: "list.faq.q4.content",
  },
  {
    id: 5,
    label: "list.faq.q5.label",
    content: "list.faq.q5.content",
  },
];

export const EVENTS = {
  pageScroll: "supply_onboard_page_scroll",
  onLandingPage: "supply_onboard_landing_page",
  onLandingFormPage: "supply_onboard_form_view",
  formSubmit: "supply_onboard_form_submit",
  ctaBtnClick: "supply_onboard_list_cta",
  category: "supply_list_with_us",
  testimonialsClick: "supply_onboard_testimonial_click",
  faqClick: "supply_onboard_faq_click",
  loginButtonClick: "supply_onboard_login_click",
};

export const LIST_WITH_US_GOOGLE_SHEET_URL =
  "https://script.google.com/macros/s/AKfycbwYg94-6-cNiwS5gNPNWJt-j7vw1U0XcDhnNCfD-mbeFnm6VUQOXe_aJ_QvazTpjHiv/exec";
